/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../Form";
import useForm from "../../hooks/useForm";
import Modal, { ModalHeader } from "../Modal";
import systemAlert from "../../utils/systemAlert";
import { ANSWERED_STATUS, BUSINESS_TYPES, CONSULTING_TYPES } from "../../constants/CONSULTING";
import { postConsultings, putConsultings } from "../../apis/admin/consulting";
import { apiFomat, getFutureDay } from "../../utils/date";
import { isEmpty } from "../../utils/lodashExtend";
import { getCompainesManagers } from "../../apis/companies/roles";
import { shallowEqual, useSelector } from "react-redux";
import { isObject } from "lodash";
import { COMPANY_TYPE } from "../../constants/COMPANY";

const defaultForm = {
  replyEmployee: null,
  replyEmployeeIdx: null,
  name: "",
  email: "",
  companyName: "",
  aboutCompany: "",
  businessType: "개인사업자",
  consultingType: "상담신청",
  mobile: "",
  employeeCount: "",
  description: "",
  entryURL: "",
  isAnswered: "대기중",
  expiredTime: getFutureDay(15, apiFomat),
  targetCompanyIdx: 'null',
  companyType: 1,
  fileIdxes: []
};

const Consulting = (props) => {

  const { company, employees } = useSelector((store) => ({
    company: store.Profile.company,
    employees: store.Data.employees,
  }), shallowEqual);
  const { selectedItem, setSelectedItem, open, setOpen, submit } = props;
  const [fields, setFields] = useState([]);
  const [mode, setMode] = useState('create');
  const [taxCompanies, setTaxCompanies] = useState([]);

  useEffect(() => {
    setValidateFields(fields);
    setMode(selectedItem ? 'detail' : 'create');

    if (open) {

      getCompainesManagers(2)
        .then(res => {

          setTaxCompanies([{ label: "선택안함", value: 'null' }, ...res.data.map(item => {
            return {
              ...item,
              value: item.idx,
              label: `${item.name} (${item.ceoName})`
            };
          })]);
        });
    }
    if (selectedItem) {

      setForm({
        ...selectedItem,
        ...(selectedItem?.demoPassword ? { expiredTime: selectedItem?.demoPassword?.expiredTime } : {}),
        replyEmployee: employees.filter((e) => e.idx === selectedItem.replyEmployeeIdx),
        isAnswered: selectedItem.isAnswered || '대기중',
        fileIdxes: selectedItem.uploadFiles,
      });
      setOriginForm({
        ...selectedItem,
        ...(selectedItem?.demoPassword ? { expiredTime: selectedItem?.demoPassword?.expiredTime } : {}),
        replyEmployee: employees.filter((e) => e.idx === selectedItem.replyEmployeeIdx),
        isAnswered: selectedItem.isAnswered || '대기중',
        fileIdxes: selectedItem.uploadFiles,
      });
    } else {
      const defaultFormData = {
        ...defaultForm,
        ...mode === 'create' ? {
          entryURL: '웹서비스 통한 문의',
          entryUrl: '웹서비스 통한 문의'
        } : {}
      };
      setForm(defaultFormData);
      setOriginForm(defaultFormData);
    }
  }, [open, selectedItem]);

  const _submit = (form) => {

    const data = {
      ...form,
      ...(!isEmpty(form.expiredTime) ? { expiredTime: `${form.expiredTime[0]} 00:00` } : {}),
      targetCompanyIdx: form.targetCompanyIdx === "null" ? null : isObject(form.targetCompanyIdx) ? form.targetCompanyIdx?.idx : form.targetCompanyIdx,
    };
    if (!isEmpty(data.replyEmployee)) {
      data.replyEmployeeIdx = data.replyEmployee[0].idx
    }


    if (mode === "create") {

      if (!data.targetCompanyIdx) {
        systemAlert(`요청세무사는 필수 입니다.`)
        return
      }
      systemAlert(`"${form.name}" 문의를 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              postConsultings(data)
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });
    } else {
      systemAlert(`"${form.name}" 문의를 수정하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              putConsultings(selectedItem.consultingIdx, data)
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });
    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {


    const taxCompany = taxCompanies.find(f => f.idx === form?.targetCompanyIdx);
    if (taxCompany && form.companyName) {
      setForm({ transferMessage: `"${form.companyName}"회사의 ${form?.consultingType} 요청이 "${taxCompany?.name}"에게 이관되었습니다.` });
    }

  }, [form.targetCompanyIdx, form.companyName]);


  useEffect(() => {
    setFields([
      [
        {
          title: "신청자",
          key: "name",
          type: "input",
          required: true,
        },
        {
          title: "이메일",
          key: "email",
          type: "input",
          validators: ['email'],
          required: true,

        },
      ],
      [
        {
          title: "회사이름",
          key: "companyName",
          type: "input",
          required: true,
        },
        {
          title: "사업형태",
          key: "businessType",
          type: "select",
          options: {
            list: BUSINESS_TYPES,
          },
        },
      ],
      [
        {
          title: "직원수",
          key: "employeeCount",
          type: "input",
          required: true,
        },
        {
          title: "신청 종류",
          key: "consultingType",
          type: "select",
          options: {
            list: CONSULTING_TYPES,
          },
        },
      ],
      [
        {
          title: "요청세무사",
          key: "targetCompanyIdx",
          type: "search-select",
          options: { list: taxCompanies },
          zIndex: 100,
          isControlShouldRenderValue: true,
          isClearable: false,
          // onChange: (data) => {
          //   setForm({ targetCompanyIdx: data });
          // },
          isHide: () => company?.type !== 9
        },
        {
          title: "회사 타입",
          key: "companyType",
          type: 'select',
          options: {
            list: COMPANY_TYPE.slice(0, COMPANY_TYPE.length - 1),
          }
        }
      ],
      [
        {
          isHide: () => company?.type !== 9,
          title: "이관 메시지",
          tooltip: "담당 세무사가 변경되었다면, 이전 세무회사에게 보내는 알림입니다.\n요청세무사가 동일하거나, 요청세무사가 없거나, 이관메시지를 입력하지 않을 경우 전송되지 않습니다.",
          key: "transferMessage",
          type: "input"
        },
      ],
      [
        {
          title: "모바일",
          key: "mobile",
          type: "input",
          validators: ['mobile'],
          required: true,
        },
      ],
      [
        {
          title: "접근 URL",
          isHide: () => {
            return mode === "create";
          },
          key: "entryURL",
          type: "text",
        },
      ],
      [
        {
          title: "비밀번호 만료일",
          key: "expiredTime",
          isHide: () => {
            return form.consultingType !== "무료체험";
          },
          type: "datePicker"
        }
      ],
      [
        {
          title: "하는일",
          key: "aboutCompany",
          type: "textarea",
        },
      ],
      [
        {
          title: "메모",
          key: "description",
          type: "textarea",
        },
      ],
      [
        {
          title: "상담 담당자",
          key: "replyEmployee",
          type: "searchemployee",
        },
      ],
      [
        {
          title: "첨부파일",
          key: "fileIdxes",
          type: "dropzone",
        },
      ],
      [
        {
          title: "답변여부",
          isHide: () => {
            return mode === "create";
          },
          key: "isAnswered",
          type: "select",
          options: {
            list: ANSWERED_STATUS,
          },
        },
      ],
    ]);

  }, [mode, form, taxCompanies, company]);

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="item-write">
        <ModalHeader>{selectedItem && <>"{selectedItem.name}"</>} 문의 {mode === "create" ? "하기" : "수정"}</ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '작성완료' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>
    </Modal>
  );
};

export default Consulting;
